































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { enums } from '@/common/enums';
import DataPanel from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import PaginationPanel from '@/components/PaginationPanel.vue';
import { DraggerImg } from '@/components';
import { formRules } from '@/common/util/validator';
import BaseContainer from '@/components/BaseContainer.vue';
import { Notification, DataDictionary } from '@/http';
import { MessageBox, Message } from 'element-ui';
import collapse from '../../utils/collapse';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: { DataPanel, PaginationPanel, BaseContainer, collapse, PageDescribe, SearchPanel, DraggerImg },
})
export default class Notifications extends Vue {
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        form: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public notificationStatusEnum = enums.notificationStatusEnum;
    public releaseRangeEnum = enums.releaseRangeEnum;
    public departmentList = [];
    public notificationTypeList = [];
    public rePagin: boolean = false;
    public total: number = 0;
    public labelPosition: string = 'right';
    // 验证规则
    public formRules = formRules;
    public form: any = {};
    public searchValue: any = {
        title: '',
        typeValue: '',
        status: null,
    };
    public loading: boolean = false;
    public listData = [];
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    mounted() {
        this.$refs.draggerImg.imgdrager();
        this.loadDataList();
        this.GetNotificationTypeList();
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadDataList();
    }
    /**
     * 获取公告类型
     */
    public async GetNotificationTypeList() {
        await DataDictionary.GetDicDetailList({ typeName: '公告类型' }).then((res) => {
            this.notificationTypeList = res;
        });
    }
    public async loadDataList() {
        this.loading = true;
        await Notification.GetPagedList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.listData = res.data;
                let skip = this.searchPagin.skip;
                this.listData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public search() {
        this.$refs.pagination.handleCurrentChange(1);
    }
    public reset() {
        this.searchValue = {
            title: '',
            typeValue: '',
            status: null,
        };
        this.loadDataList();
    }
    tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
            return '';
        }
        return 'success-row';
    }
    public add() {
        this.$router.push({
            path: '/notificationsEdit',
            query: {
                pageTitle: '新增通知公告',
            },
        });
    }
    public edit(row) {
        this.$router.push({
            path: '/notificationsEdit',
            query: {
                pageTitle: '编辑通知公告',
                id: row.id,
            },
        });
    }
    toSkip(row) {
        this.$router.push({
            path: '/notificationsDetail',
            query: {
                id: row.id,
            },
        });
    }
    public srow: any;
    public del(row) {
        this.srow = row;
        this.dialogConfig = {
            title: '删除此通知公告',
            show: true,
        };
    }
    async confirmOk() {
        Notification.DelNotification(this.srow.id).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!',
            });
            this.loadDataList();
        });
        this.dialogConfig = {
            show: false,
        };
    }
}
